/* =============================================
 * 布局状态管理模块
 * 规范：所有布局状态唯一入口，组件禁止私自维护重复状态
 * ============================================= */

const state = {
  styleType: sessionStorage.getItem('layoutStyleType') || 'business',
  showAside: true,
  isCollapse: false,
  screenType: 'desktop', // 统一枚举：desktop/tablet/mobile，与mixin完全对齐
  menuList: [],          // 完整一级菜单树
  subMenuList: [],       // 当前侧边栏子菜单
  currentModulePath: '', // 当前选中的一级模块路径（头部导航+侧边栏下拉 唯一数据源）
  tagList: JSON.parse(sessionStorage.getItem('layoutTagList') || '[]'),
  activeTagIndex: Number(sessionStorage.getItem('layoutActiveTag') || -1),
  systemName: localStorage.getItem('headerTitle') || '云管系统',
  headerLogo: localStorage.getItem('headerLogo') || './static/images/login.png',
  breadcrumbList: []
}

const mutations = {
  // 设置主题，同步全局类名
  SET_STYLE_TYPE(state, type) {
    state.styleType = type
    sessionStorage.setItem('layoutStyleType', type)
    document.documentElement.className = `theme-${type}`
  },
  SET_SHOW_ASIDE(state, isShow) {
    state.showAside = isShow
  },
  SET_COLLAPSE(state, isCollapse) {
    state.isCollapse = isCollapse
    // 同步CSS变量，全局布局自动适配
    const width = isCollapse ? 'var(--aside-collapsed-width)' : 'var(--aside-width)'
    document.documentElement.style.setProperty('--aside-current-width', width)
  },
  SET_SCREEN_TYPE(state, type) {
    state.screenType = type
    state.showAside = type !== 'mobile'
  },
  // 设置完整菜单，自动初始化默认选中
  SET_MENU_LIST(state, list) {
    state.menuList = list
    // 自动选中第一个有子菜单的一级模块
    const firstModule = list.find(item => item.children?.length) || list[0]
    if (firstModule) {
      state.currentModulePath = firstModule.path || ''
      state.subMenuList = firstModule.children || []
    }
  },
  SET_SUB_MENU_LIST(state, list) {
    state.subMenuList = list
  },
  // 切换当前一级模块（头部/侧边栏通用）
  SET_CURRENT_MODULE(state, menu) {
    state.currentModulePath = menu.path || ''
    state.subMenuList = menu.children || []
  },
  ADD_TAG(state, tag) {
    const existIndex = state.tagList.findIndex(item => item.path === tag.path)
    if (existIndex === -1) state.tagList.push(tag)
    state.activeTagIndex = existIndex === -1 ? state.tagList.length - 1 : existIndex
    sessionStorage.setItem('layoutTagList', JSON.stringify(state.tagList))
    sessionStorage.setItem('layoutActiveTag', state.activeTagIndex)
  },
  REMOVE_TAG(state, index) {
    state.tagList.splice(index, 1)
    if (index <= state.activeTagIndex) state.activeTagIndex = Math.max(0, state.activeTagIndex - 1)
    sessionStorage.setItem('layoutTagList', JSON.stringify(state.tagList))
    sessionStorage.setItem('layoutActiveTag', state.activeTagIndex)
  },
  SET_SYSTEM_INFO(state, info) {
   if (info.systemName && info.systemName !== 'undefined') {
     state.systemName = info.systemName
     localStorage.setItem('headerTitle', info.systemName)
   }
   if (info.headerLogo && info.headerLogo !== 'undefined') {
     state.headerLogo = info.headerLogo
     localStorage.setItem('headerLogo', info.headerLogo)
   }
  },


  SET_ACTIVE_TAG(state, index) {
    state.activeTagIndex = index
    sessionStorage.setItem('layoutActiveTag', index)
  },
  // 新增：清空所有标签页（state + 本地缓存同步清除）
  CLEAR_TAG_LIST(state) {
    state.tagList = []
    state.activeTagIndex = -1
    sessionStorage.removeItem('layoutTagList')
    sessionStorage.removeItem('layoutActiveTag')
  }
}

const actions = {
  initTheme({ commit }) {
    const type = sessionStorage.getItem('layoutStyleType') || 'business'
    commit('SET_STYLE_TYPE', type)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// /* =============================================
//  * 布局状态管理模块
//  * 规范：所有布局状态修改必须通过 commit 触发，禁止子组件直接修改
//  * Vue3升级：可直接迁移为 Pinia 模块，语法几乎一致
//  * ============================================= */

// const state = {
//   styleType: sessionStorage.getItem('layoutStyleType') || 'business', // 主题类型
//   showAside: true,          // 侧边栏显示状态
//   isCollapse: false,        // 侧边栏折叠状态
//   screenType: 'desktop',    // 设备类型：mobile/tablet/desktop
//   menuList: [],             // 完整菜单列表
//   subMenuList: [],          // 当前侧边栏子菜单
//   tagList: JSON.parse(sessionStorage.getItem('layoutTagList') || '[]'),     // 标签页列表
//   activeTagIndex: Number(sessionStorage.getItem('layoutActiveTag') || -1), // 激活标签索引
//   breadcrumbList: []        // 面包屑列表
// }

// const mutations = {
//   // 设置主题
//   SET_STYLE_TYPE(state, type) {
//     state.styleType = type
//     sessionStorage.setItem('layoutStyleType', type)
//     document.documentElement.className = `theme-${type}` // 全局主题类名
//   },
//   // 切换侧边栏显示
//   TOGGLE_ASIDE(state) {
//     state.showAside = !state.showAside
//   },
//   // 直接设置侧边栏显示状态，配合抽屉双向同步
//   SET_SHOW_ASIDE(state, isShow) {
//     state.showAside = isShow
//   },
//   // 设置侧边栏折叠
//   SET_COLLAPSE(state, isCollapse) {
//     state.isCollapse = isCollapse
//   },
//   // 设置设备类型
//   SET_SCREEN_TYPE(state, type) {
//     state.screenType = type
//     state.showAside = type !== 'mobile' // 移动端默认隐藏侧边栏
//   },
//   // 设置完整菜单
//   SET_MENU_LIST(state, list) {
//     state.menuList = list
//   },
//   // 设置当前子菜单
//   SET_SUB_MENU_LIST(state, list) {
//     state.subMenuList = list
//   },
//   // 添加标签页
//   ADD_TAG(state, tag) {
//     const existIndex = state.tagList.findIndex(item => item.path === tag.path)
//     if (existIndex === -1) state.tagList.push(tag)
//     state.activeTagIndex = existIndex === -1 ? state.tagList.length - 1 : existIndex
//     sessionStorage.setItem('layoutTagList', JSON.stringify(state.tagList))
//     sessionStorage.setItem('layoutActiveTag', state.activeTagIndex)
//   },
//   // 删除标签页
//   REMOVE_TAG(state, index) {
//     state.tagList.splice(index, 1)
//     if (index <= state.activeTagIndex) state.activeTagIndex = Math.max(0, state.activeTagIndex - 1)
//     sessionStorage.setItem('layoutTagList', JSON.stringify(state.tagList))
//     sessionStorage.setItem('layoutActiveTag', state.activeTagIndex)
//   },
//   // 设置激活标签
//   SET_ACTIVE_TAG(state, index) {
//     state.activeTagIndex = index
//     sessionStorage.setItem('layoutActiveTag', index)
//   }
// }

// const actions = {
//   initTheme({ commit }) {
//     const type = sessionStorage.getItem('layoutStyleType') || 'business'
//     commit('SET_STYLE_TYPE', type)
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   mutations,
//   actions
// }